import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { DashboardTemplateResponse, DashboardTemplateCreateRequest, DashboardTemplateUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { DashboardTemplatesDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { DashboardsService } from 'app/services';
import { RegisterEntityHandler } from '..';

@RegisterEntityHandler('dashboardtemplate')
@Injectable()
export class DashboardTemplateHandler extends EntityHandler<DashboardTemplateResponse> {

    constructor(
        admin: AdminEditorService,
        private dashboards: DashboardsService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listDashboardTemplates/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listDashboardTemplates(ownerId, false, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'dashboardtemplate',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.DASHBOARDTEMPLATES'),
        }));
    }

    getEntity(id: string, bypassCache?: boolean): Promise<DashboardTemplateResponse> {
        return this.admin.getCached(`getDashboardTemplate/${id}`, api => api.entities.getDashboardTemplate(id), 10, bypassCache);
    }

    createEntity(ownerId: string, entity: DashboardTemplateCreateRequest): Promise<DashboardTemplateResponse> {
        return this.admin.applyUpdate(api => api.entities.createDashboardTemplate({
            ...entity,
            ownerId,
            user: this.admin.user,
            public: !!entity.public,
        }), { _type: 'dashboardtemplate' });
    }

    setEntityState(entity: any, state: 'active' | 'deleted'): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateDashboardTemplate(entity.id, { state }), { _type: 'dashboardtemplate' });
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.DASHBOARD_TEMPLATES.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.dashboard),
            grid.TextColumn('description', 'DESCRIPTION'),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<DashboardTemplateResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new DashboardTemplatesDetailsSectionHandler(this.admin, ownerId, this.dashboards, false),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: DashboardTemplateUpdateRequest, sections: FormSectionHandler<DashboardTemplateResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'dashboardtemplate',
            entity: {}, // set up some defaults if you want
            sections: [
                new DashboardTemplatesDetailsSectionHandler(this.admin, ownerId, this.dashboards, true),
            ],
        });
    }

}












